import PropTypes from 'prop-types';
import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { FaInfoCircle } from 'react-icons/fa';

const LimitLengthContentPopover = ({ items, maxLength }) => {
    const commaSeparatedContent = items.join(', ');

    if (commaSeparatedContent.length <= maxLength) {
        return commaSeparatedContent;
    }

    return (
        <span>
            <span>{commaSeparatedContent.substring(0, maxLength)} (...)</span>
            <OverlayTrigger
                trigger="click"
                rootClose
                placement="bottom"
                overlay={
                    <Popover id="expanded-content-popover" className="increase-popover-width">
                        <Popover.Content>
                            {items.map((item) => (
                                <div key={item}>{item}</div>
                            ))}
                        </Popover.Content>
                    </Popover>
                }
            >
                <button type="button" aria-label="Show full list" style={{ background: 'none', border: 0, padding: 0, cursor: 'pointer', marginLeft: 3 }}><FaInfoCircle aria-hidden="true" focusable="false" /></button>
            </OverlayTrigger>
        </span>
    );
};

LimitLengthContentPopover.propTypes = {
    items: PropTypes.arrayOf(PropTypes.string).isRequired,
    maxLength: PropTypes.number,
};

LimitLengthContentPopover.defaultProps = {
    maxLength: 40,
};

export default LimitLengthContentPopover;
